import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Paper, Button } from '@mui/material';

//Icons
import SaveIcon from '@mui/icons-material/Save';
import FeatherIcon from 'feather-icons-react';
import LoadingButton from '@mui/lab/LoadingButton';

//Actions
import ShowNotification from '../../../../../../utils/redux/actions/global/notifications/NotificationAction';
import EditIntervencao from '../../../../../../utils/redux/actions/intervencoes/EditIntervencaoAction';
import GetObras from '../../../../../../utils/redux/actions/intervencoes/GetObrasAction';
import GetIntervencoes from '../../../../../../utils/redux/actions/intervencoes/GetIntervencoesAction';

//Components
import Spinner from '../../../../../../Global/Components/Spinner';
import Documentos from '../sectionsConsultar/Documentos';
import Detalhes from './components/sectionsConsultar/Detalhes';
import Controlo from './components/sectionsConsultar/Controlo';
import Calendario from '../sectionsConsultar/Calendario';
import HistoricoEsperas from './components/sectionsConsultar/historicoEsperas';

const FormConsultaMobile = ({
  intervencaoSelecionada,
  toggleDrawer,
  classes,
  dimensions,
  handleSubmitForm,
}) => {
  const dispatch = useDispatch();
  const [obraId, setObraId] = useState();

  const [files, setFiles] = useState([]);
  const [newFiles, setNewFiles] = useState([]);
  const [removeFiles, setRemoveFiles] = useState([]);
  const [images, setImages] = useState([]);
  const [newImages, setNewImages] = useState([]);
  const [removeImages, setRemoveImages] = useState([]);
  const [guardarLoading, setGuardarLoading] = useState(false);

  const message = {
    isOpen: true,
    message: 'Intervenção editada com sucesso!!',
    type: 'success',
  };
  const errorMessage = {
    isOpen: true,
    message: 'Ocorreu um erro!!',
    type: 'error',
  };
  const fileWarning = {
    isOpen: true,
    message: 'Ficheiros com o mesmo nome não serão adicionados!',
    type: 'warning',
  };

  const fetchIntervencoes = () => {
    dispatch(GetIntervencoes());
  };
  const fetchObras = () => {
    dispatch(GetObras());
  };

  useEffect(() => {
    fetchIntervencoes();
    fetchObras();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setObraId(intervencaoSelecionada && intervencaoSelecionada.obraId);
  }, [intervencaoSelecionada]);

  const onSubmit = (e) => {
    const intId = intervencaoSelecionada && intervencaoSelecionada.id;
    console.log(intId);

    const ydata = [
      {
        navNumProposta: intId,
      },
    ];

    setGuardarLoading(true);

    dispatch(
      EditIntervencao(
        ydata,
        //images,
        newImages,
        removeImages,
        //files
        newFiles,
        removeFiles,
        intId,
        toggleDrawer,
        ShowNotification,
        message,
        errorMessage
      )
    )
      .then(() => fetchIntervencoes())
      .then(() => setGuardarLoading(false));
  };

  return (
    <>
      {intervencaoSelecionada ? (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            padding: '40px 20px 40px 20px',
            height: '100%',
          }}
        >
          <form onSubmit={handleSubmitForm(onSubmit)}>
            <div className={classes.drawerHeader}>
              <div
                style={{
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                }}
                onClick={() => toggleDrawer('right', false)}
              >
                <div>
                  <FeatherIcon
                    icon='chevron-left'
                    size={20}
                    style={{ strokeWidth: '1.5' }}
                  />
                </div>
                <div className='text-underline-close-drawer'>
                  Lista de Intervenções
                </div>
              </div>
              {!guardarLoading ? (
                <Button className={classes.btnGuardar} type='submit'>
                  Guardar
                </Button>
              ) : (
                <LoadingButton
                  color='secondary'
                  loading={guardarLoading}
                  loadingPosition='start'
                  startIcon={<SaveIcon />}
                  variant='contained'
                  type='submit'
                  className={classes.btnGuardar}
                >
                  Guardar
                </LoadingButton>
              )}
            </div>

            <Paper sx={{ px: 3, py: 1, mt: 4 }}>
              <h4
                style={{
                  fontSize: '22px',
                  width: '100%',
                  marginBottom: '0px',
                }}
                className='text-underline'
              >
                Caracterização da Intervenção
              </h4>

              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  width: '100%',
                  marginTop: '20px',
                  justifyContent: 'space-between',
                  flexWrap: 'wrap',
                }}
              >
                <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                  <Detalhes
                    intervencaoSelecionada={intervencaoSelecionada}
                    obraId={obraId}
                  />
                  <Controlo intervencaoSelecionada={intervencaoSelecionada} />
                </div>
                <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                  <Calendario intervencaoSelecionada={intervencaoSelecionada} />
                  {intervencaoSelecionada &&
                  intervencaoSelecionada.esperas &&
                  intervencaoSelecionada.esperas.length > 0 ? (
                    <HistoricoEsperas
                      intervencaoSelecionada={intervencaoSelecionada}
                    />
                  ) : null}
                </div>
                <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                  <Documentos
                    intervencaoSelecionada={intervencaoSelecionada}
                    classes={classes}
                    dimensions={dimensions}
                    //Imagens
                    images={images}
                    setImages={setImages}
                    newImages={newImages}
                    setNewImages={setNewImages}
                    removeImages={removeImages}
                    setRemoveImages={setRemoveImages}
                    //Documentos
                    files={files}
                    setFiles={setFiles}
                    newFiles={newFiles}
                    setNewFiles={setNewFiles}
                    removeFiles={removeFiles}
                    setRemoveFiles={setRemoveFiles}
                    //Errors
                    message={message}
                    errorMessage={errorMessage}
                    fileWarning={fileWarning}
                    ShowNotification={ShowNotification}
                  />
                </div>
              </div>
            </Paper>
          </form>
        </div>
      ) : (
        <div
          style={{
            display: 'flex',
            height: '100vh',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Spinner />
        </div>
      )}
    </>
  );
};

export default FormConsultaMobile;
